<template>
  <div id="app" @click.stop="onClick" v-scroll="onScroll">
    <adx-account />
    <adx-alert :group="'saved'" :duration="3000" />
    <adx-release-hijack v-if="hijacked && hijacker.token"/>
    <header :class="{noHeader : isHeader, fixedHeaderMobile : fixedHeaderMobile}">
      <div class="container">
        <menu-bar :showFooterMobile="showFooterMobile"/>
      </div>
    </header>
    <main class="container" :class="{ containerOverride : isContainerOverride}">
      <router-view />
    </main>
    <adx-footer :class="{noFooter : isFooter}" />
  </div>
</template>

<script>
import Vue from "vue";

import MenuBar from '@/components/MenuBar';
import SideBar from "@/components/SideBar/Desktop"
import AdxFooter from "@/components/Footer"
import Alert from "@/components/Alert"
import Account from "@/components/Account"
import ReleaseHijack from '@/components/ReleaseHijack';
import Media from 'vue-media';
import VueScroll from 'vue-scroll'

import { mapGetters, mapActions, mapMutations } from 'vuex'

Vue.$broker = new Vue();
Vue.use(VueScroll)

export default {
  name: 'adx-app',
  components: {
    'menu-bar': MenuBar,
    'media': Media,
    'sidebar-menu': SideBar,
    'adx-footer': AdxFooter,
    'adx-alert': Alert,
    'adx-account': Account,
    'adx-release-hijack': ReleaseHijack
  },
  head: {
    title: {
      inner: 'Home'
    },
    meta: [
      {
      name: 'description', content: 'Beriklan sekarang lebih lengkap, lebih mudah, lebih murah .Adxasia.co.id #1 Marketplace pertama di Indonesia untuk beriklan Beriklan dilebih dari 400 channel Dipercaya lebih dari 150 klien.Jangkau lebih banyak pelanggan dan tingkatkan bisnis Anda' , id: 'desc'
      },
    ],
    script: [
      {
        type: 'text/javascript',
        i: `window.heap = window.heap || [], heap.load = function (e, t) { window.heap.appid = e, window.heap.config = t = t || {}; var r = t.forceSSL || "https:" === document.location.protocol, a = document.createElement("script"); a.type = "text/javascript", a.async = !0, a.src = (r ? "https:" : "http:") + "//cdn.heapanalytics.com/js/heap-" + e + ".js"; var n = document.getElementsByTagName("script")[0]; n.parentNode.insertBefore(a, n); for (var o = function (e) { return function () { heap.push([e].concat(Array.prototype.slice.call(arguments, 0))) } }, p = ["addEventProperties", "addUserProperties", "clearEventProperties", "identify", "resetIdentity", "removeEventProperty", "setEventProperties", "track", "unsetEventProperty"], c = 0; c < p.length; c++)heap[p[c]] = o(p[c]) };
            heap.load("${process.env.VUE_APP_HEAP_CLIENT_ID}");`
      },
      {
        src: `https://www.googletagmanager.com/gtag/js?id=${process.env.VUE_APP_GOOGLE_ANALYTIC_ID}`,
        async: true
      },
      {
        i: `window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${process.env.VUE_APP_GOOGLE_ANALYTIC_ID}');`
      },
      {
        i: `!function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '2171068832957021');
            fbq('track', 'PageView');`
      }
    ]
  },
  data() {
    return {

    }
  },
  mounted(){
    if(this.token){
      this.$store.dispatch('loadSaved', {})
    }
  },
  methods: {
    onClick(event) {
      Vue.$broker.$emit("app-click");
    },
    onScroll(event) {
      Vue.$broker.$emit('on-scroll')
    },
  },
  computed: {
    ...mapGetters({
      token: 'token',
      hijacked: 'hijacked',
      hijacker: 'hijacker'
    }),
    isHeader() {
      const routerName = this.$route.name

      if(routerName == 'invoicereceipt'
      || routerName == 'paymentreceipt'
      || routerName == 'orderreceipt'
      || routerName == 'invoice-anon'
      || routerName == 'terminal'
      || routerName == 'billboardmap') {
        return true
      }

      return false
    },
    isFooter() {
      const routerName = this.$route.name

      if(routerName == 'invoicereceipt'
      || routerName == 'paymentreceipt'
      || routerName == 'orderreceipt'
      || routerName == 'invoice-anon'
      || routerName == 'bus'
      || routerName == 'buscampaigneditorbrowse'
      || routerName == 'taskassignment'
      || routerName == 'terminal'
      || routerName == 'detailspbuv2'
      || routerName == 'billboardmap'
      || routerName == 'mediaownerdashboard') {
        return true
      }
      return false
    },
    showFooterMobile() {
      const routerName = this.$route.name

      if(routerName == 'detailspbuv2'
      || routerName == 'detailpagebus'
      || routerName == 'bus') {
        return false
      }
      return true
    },
    fixedHeaderMobile(){
      const routerName = this.$route.name

      if (routerName == 'detailpagebus'
      || routerName == 'detailspbuv2'){
        return true
      }
      return false
    },
    isContainerOverride(){
      const routerName = this.$route.name

      if (routerName == 'mediaownerdashboard'){
        return true
      }      
      return false
    }
  },
}
</script>

<style lang="scss">
@import "~@/styles/base";
@import "~@/styles/typography";
@import "~@/styles/fonts";
@import "~@/styles/icons";
@import "~@/styles/adx-font_icon";
@import "~@/styles/mixins";
// TODO: THIS STYLE IS STILL SEPARATED WITH OTHERS. CONTAIN *ONLY* BUS AND AIRLINES ICONS. 
// BETTER COMBINE THIS TO OTHER STYLE :) 
@import "~@/styles/adx-menu_icon";
</style>